package chand.wordvoyage.ui

import androidx.compose.runtime.Composable

@Composable
actual fun AdBanner() {
    // No-op on Web (JS) — AdMob is Android-only
}

